(function () {
  'use strict';

  function initMobileNav() {
    var btn = document.querySelector('.kp-hamburger');
    var drawer = document.getElementById('kp-mobile-drawer');
    if (!btn || !drawer) return;

    var header = document.querySelector('.kp-header');
    var focusableEls = drawer.querySelectorAll('a[href], button');
    var firstFocusable = focusableEls[0];
    var lastFocusable = focusableEls[focusableEls.length - 1];

    function syncDrawerTop() {
      if (header) drawer.style.paddingTop = header.offsetHeight + 'px';
    }
    syncDrawerTop();

    function open() {
      btn.setAttribute('aria-expanded', 'true');
      btn.setAttribute('aria-label', 'Cerrar menú de navegación');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (firstFocusable) firstFocusable.focus();
    }

    function close() {
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Abrir menú de navegación');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      btn.focus();
    }

    btn.addEventListener('click', function () {
      btn.getAttribute('aria-expanded') === 'true' ? close() : open();
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();

      if (e.key === 'Tab' && drawer.classList.contains('is-open')) {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
          }
        } else {
          if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      }
    });

    var touchStartX = 0;
    drawer.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    drawer.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].screenX - touchStartX;
      if (diff > 80) close();
    }, { passive: true });

    window.addEventListener('resize', function () {
      syncDrawerTop();
      if (window.innerWidth > 768 && drawer.classList.contains('is-open')) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNav);
  } else {
    initMobileNav();
  }
})();
